/* Greylongg V2 chrome: drawers, mobile nav, sticky header, search overlay,
   cart drawer, tab bar (greylongg-shopify-connection, 2026-10-07) and, since
   2026-10-09, modals (size guide: focus trap, in / cm toggle, chart tabs).
   Any link whose URL hash is "#gl-<id>" opens the drawer / overlay / modal with
   that id, so textarea-driven links (footer, mobile menu) need no attributes.
   Loaded with defer by the header, cart drawer, size guide and footer sections;
   the guard makes repeats a no-op. Exposes window.GL.openLayer / closeLayers /
   renderCart, which gl-home.js uses after a quick add. */
(function () {
  "use strict";
  window.GL = window.GL || {};
  if (window.GL.chrome) return;
  window.GL.chrome = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* Layers: drawers, search overlay, modals, scrim ---------------------------- */
  var LAYERS = ".gl-drawer, .gl-search-overlay, .gl-modal";
  var OPEN_LAYERS = ".gl-drawer.is-open, .gl-search-overlay.is-open, .gl-modal.is-open";
  var lastTrigger = null;

  function scrim() { return $(".gl-scrim"); }

  function focusables(root) {
    return $$("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])", root)
      .filter(function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
  }

  /* The layer a "#gl-…" link points at, if it exists on this page. */
  function layerFor(link) {
    if (!link || !link.hash || link.hash.indexOf("#gl-") !== 0) return null;
    var layer = document.getElementById(link.hash.slice(1));
    return layer && layer.matches(LAYERS) ? layer : null;
  }

  function openLayer(id, trigger) {
    var layer = typeof id === "string" ? document.getElementById(id) : id;
    if (!layer) return;
    closeLayers(true);
    lastTrigger = trigger || (document.activeElement !== document.body ? document.activeElement : null);
    layer.classList.add("is-open");
    layer.setAttribute("aria-hidden", "false");
    if (scrim()) scrim().classList.add("is-open");
    document.body.classList.add("gl-locked");
    var input = $("input[type=search]", layer);
    if (input) { setTimeout(function () { input.focus(); }, 200); return; }
    if (layer.classList.contains("gl-modal")) {
      var target = $("[data-gl-close]", layer) || focusables(layer)[0];
      if (target) setTimeout(function () { target.focus(); }, 50);
    }
  }

  /* keepFocus: switching layers, so leave focus and the remembered trigger alone. */
  function closeLayers(keepFocus) {
    var open = $$(OPEN_LAYERS);
    open.forEach(function (l) {
      l.classList.remove("is-open");
      l.setAttribute("aria-hidden", "true");
    });
    if (scrim()) scrim().classList.remove("is-open");
    document.body.classList.remove("gl-locked");
    if (keepFocus) return;
    if (open.length && lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-gl-open]");
    if (open) { e.preventDefault(); openLayer(open.getAttribute("data-gl-open"), open); return; }
    var link = e.target.closest("a[href*='#gl-']");
    var layer = layerFor(link);
    if (layer) { e.preventDefault(); openLayer(layer, link); return; }
    if (e.target.closest("[data-gl-close]")) { e.preventDefault(); closeLayers(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeLayers(); return; }
    if (e.key !== "Tab") return;
    var dialog = $("[role=dialog].is-open");
    if (!dialog) return;
    var items = focusables(dialog);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], inside = dialog.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });

  /* Mobile nav drawer: built from the desktop mega menus ------------------- */
  function buildMobileNav() {
    var mnav = $("[data-gl-mnav]");
    if (!mnav || mnav.dataset.built) return;
    mnav.dataset.built = "1";
    /* A plain Shopify menu (no image tiles) gets text-only rows instead of thumbnail placeholders. */
    var plain = !$(".gl-main-nav .gl-mega__tile img");
    mnav.classList.toggle("gl-mnav--plain", plain);
    $$(".gl-main-nav__item").forEach(function (item, i) {
      var link = $(".gl-main-nav__link", item);
      var tile = $(".gl-mega__tile img", item);
      var mega = $(".gl-mega", item);
      var row = document.createElement(mega ? "button" : "a");
      row.className = "gl-mnav__row";
      if (mega) {
        row.type = "button";
        row.setAttribute("aria-expanded", "false");
        row.setAttribute("aria-controls", "gl-mnav-panel-" + i);
      } else {
        row.href = link.getAttribute("href");
      }
      var thumb = tile ? (tile.getAttribute("src") || tile.currentSrc || tile.src) : "";
      var label = link.textContent.trim();
      row.innerHTML = (thumb ? '<img src="' + thumb + '" alt="' + esc((tile && tile.getAttribute("alt")) || label) + '" loading="lazy">' : plain ? "" : '<span class="gl-mnav__noimg"></span>') +
        "<span>" + esc(label) + "</span>" +
        (mega ? '<svg class="gl-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' : "");
      mnav.appendChild(row);
      if (!mega) return;

      var panel = document.createElement("div");
      panel.className = "gl-mnav__panel";
      panel.id = "gl-mnav-panel-" + i;
      var foot = $(".gl-mega__foot .gl-text-link", item);
      if (foot) panel.appendChild(foot.cloneNode(true));
      $$(".gl-mega__col, .gl-mega__brands", item).forEach(function (col) {
        if (col.children.length) panel.appendChild(col.cloneNode(true));
      });
      row.addEventListener("click", function () {
        var open = panel.classList.toggle("is-open");
        row.setAttribute("aria-expanded", open ? "true" : "false");
      });
      mnav.appendChild(panel);
    });
  }

  /* Sticky header shrink --------------------------------------------------- */
  /* Two thresholds, not one: shrinking takes 24px out of the page, and scroll
     anchoring then moves scrollY up by the same amount, so a single threshold
     flickers between the two states near it. The gap (40..120) is wider than
     the height change, so each state is stable once entered. */
  function initSticky() {
    var header = $(".gl-site-header[data-shrink]");
    if (!header || header.dataset.stickyReady) return;
    header.dataset.stickyReady = "1";
    var ticking = false, shrunk = false;
    var update = function () {
      ticking = false;
      var y = window.scrollY;
      var next = y > 120 ? true : y < 40 ? false : shrunk;
      if (next === shrunk) return;
      shrunk = next;
      header.classList.toggle("is-scrolled", shrunk);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  /* Search overlay: Shopify predictive search --------------------------------- */
  function money(amount, format) {
    var n = Number(amount);
    var s = isNaN(n) ? String(amount) : n.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (format || "{{amount}}").replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }

  function initSearch() {
    var overlay = $("#gl-search-overlay");
    if (!overlay || overlay.dataset.ready) return;
    overlay.dataset.ready = "1";
    var input = $("input[type=search]", overlay);
    var results = $(".gl-search-results", overlay);
    var format = overlay.dataset.moneyFormat || "{{amount}}";
    var limit = Number(overlay.dataset.limit) || 4;
    var timer, last = "";

    function run() {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ""; return; }
      if (q === last) return;
      last = q;
      var url = root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=" + limit + "&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,tag";
      fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (input.value.trim() !== q) return;
          var products = (json.resources && json.resources.results && json.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<p class="gl-search-none">No matches for "' + q.replace(/</g, "&lt;") + '". <a href="' + root + 'search?q=' + encodeURIComponent(q) + '">Search all products</a></p>';
            return;
          }
          results.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") + '" alt="' + esc(p.featured_image.alt || p.title) + '" loading="lazy">' : '<span class="gl-search-result__noimg"></span>';
            return '<a class="gl-search-result" href="' + p.url + '">' + img + "<div>" + esc(p.title) + "<span>" + money(p.price, format) + "</span></div></a>";
          }).join("") + '<p class="gl-search-all"><a class="gl-text-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '">All results for "' + q.replace(/</g, "&lt;") + '"</a></p>';
        })
        .catch(function () { results.innerHTML = ""; });
    }

    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    $$(".gl-chip", overlay).forEach(function (chip) {
      chip.addEventListener("click", function () { input.value = chip.textContent.trim(); run(); });
    });
  }

  /* Cart drawer ------------------------------------------------------------- */
  function cartDrawer() { return $("#gl-cart-drawer"); }

  function renderCart(html, open) {
    var drawer = cartDrawer();
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.getElementById("gl-cart-drawer");
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    drawer.setAttribute("data-count", fresh.getAttribute("data-count") || "0");
    updateCount(fresh.getAttribute("data-count") || "0");
    drawer.classList.remove("is-busy");
    if (open) openLayer(drawer);
  }

  function updateCount(count) {
    $$(".gl-cart-count").forEach(function (el) { el.textContent = count; el.setAttribute("data-count", count); });
  }

  function changeLine(line, quantity) {
    var drawer = cartDrawer();
    drawer.classList.add("is-busy");
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity, sections: "gl-cart-drawer", sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.sections && json.sections["gl-cart-drawer"]) { renderCart(json.sections["gl-cart-drawer"], false); }
        else { drawer.classList.remove("is-busy"); }
        if (json.status || json.message) {
          var err = $(".gl-cart-error", drawer) || document.createElement("p");
          err.className = "gl-cart-error";
          err.textContent = json.description || json.message || "Could not update the cart.";
          var body = $(".gl-drawer__body", drawer);
          if (body) body.prepend(err);
        }
      })
      .catch(function () { drawer.classList.remove("is-busy"); });
  }

  document.addEventListener("click", function (e) {
    var qty = e.target.closest("[data-gl-qty]");
    var remove = e.target.closest("[data-gl-remove]");
    if (!qty && !remove) return;
    e.preventDefault();
    var el = qty || remove;
    var line = Number(el.getAttribute("data-gl-line"));
    var quantity = remove ? 0 : Math.max(0, Number(el.getAttribute("data-gl-current")) + Number(el.getAttribute("data-gl-qty")));
    changeLine(line, quantity);
  });

  /* Size guide modal: in / cm toggle, chart tabs ----------------------------- */
  function toCm(inches) { return Math.round(inches * 2.54 * 2) / 2; }
  function toIn(cm) { return Math.round(cm / 2.54 * 2) / 2; }

  /* Cells carry their source value in data-in or data-cm; anything that is not
     a plain number (e.g. "38-40") is left as written. */
  function setUnit(root, unit) {
    $$("[data-gl-unit]", root).forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-gl-unit") === unit ? "true" : "false");
    });
    $$("td[data-in], td[data-cm]", root).forEach(function (td) {
      var base = td.hasAttribute("data-in") ? "in" : "cm";
      var raw = td.getAttribute("data-" + base).trim();
      var n = parseFloat(raw);
      if (isNaN(n) || String(n) !== raw) return;
      td.textContent = base === unit ? raw : String(unit === "cm" ? toCm(n) : toIn(n));
    });
    try { localStorage.setItem("gl-size-unit", unit); } catch (err) { /* private mode */ }
  }

  function savedUnit() {
    try { return localStorage.getItem("gl-size-unit"); } catch (err) { return null; }
  }

  document.addEventListener("click", function (e) {
    var unit = e.target.closest("[data-gl-unit]");
    if (unit) { setUnit(unit.closest(".gl-modal") || document, unit.getAttribute("data-gl-unit")); return; }
    var tab = e.target.closest(".gl-modal [role=tab]");
    if (!tab) return;
    $$("[role=tab]", tab.closest("[role=tablist]")).forEach(function (t) {
      var on = t === tab;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute("aria-controls"));
      if (panel) panel.hidden = !on;
    });
  });

  /* Init -------------------------------------------------------------------- */
  var hashChecked = false;

  function init() {
    buildMobileNav();
    initSticky();
    initSearch();
    if ($(".gl-tabbar")) document.body.classList.add("gl-has-tabbar");
    if (savedUnit() === "cm") $$(".gl-modal").forEach(function (m) { setUnit(m, "cm"); });
    if (!hashChecked && location.hash.indexOf("#gl-") === 0) {
      hashChecked = true;
      var target = document.getElementById(location.hash.slice(1));
      if (target && target.classList.contains("gl-modal")) openLayer(target);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () {
    var mnav = $("[data-gl-mnav]");
    if (mnav) { delete mnav.dataset.built; mnav.innerHTML = ""; }
    init();
  });
  /* Theme editor: a modal's only content is hidden, so show it while its section is selected. */
  document.addEventListener("shopify:section:select", function (e) {
    var modal = e.target && e.target.querySelector ? e.target.querySelector(".gl-modal") : null;
    if (modal) openLayer(modal);
  });
  document.addEventListener("shopify:section:deselect", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(".gl-modal.is-open")) closeLayers();
  });

  window.GL.openLayer = openLayer;
  window.GL.closeLayers = closeLayers;
  window.GL.renderCart = renderCart;
  window.GL.initChrome = init;
})();
